import { PLATFORM_ENDPOINT_LOCAL_NAME_MAX_LENGTH } from "@multi-chat/shared";

export function trimmedChannelLocalName(value: string): string {
  return value.trim();
}

/** Card primary line: persisted local name, otherwise the provider title. */
export function channelCardTitle(
  localName: string | null | undefined,
  providerTitle: string,
): string {
  const stored = typeof localName === "string" ? trimmedChannelLocalName(localName) : "";
  return stored.length > 0 ? stored : providerTitle;
}

/** Save stays off until the draft is a non-blank name that differs from the stored one. */
export function canSaveChannelLocalName(input: {
  canEdit: boolean;
  saving: boolean;
  savedName: string;
  draft: string;
}): boolean {
  if (!input.canEdit || input.saving) return false;
  const next = trimmedChannelLocalName(input.draft);
  if (next.length < 1 || next.length > PLATFORM_ENDPOINT_LOCAL_NAME_MAX_LENGTH) return false;
  return next !== trimmedChannelLocalName(input.savedName);
}
